export const PROFILE_POST_ADDRESS_INHABITANT_DATA = {
  address:
    '0042/3 Stiege B, Eichenstraße 12–18, Apt. 19, Hausverwaltung Wiener Wohnen GmbH, Building Section 3',
  address_2: 'Apartment No. 19, 3rd Floor, Unit B-3-19',
  city: 'Vienna, Federal Capital City of Austria',
  country: 'Republic of Austria (EU Member State)',
  notes:
    'The address corresponds to a residential apartment located within a managed housing complex operated by a local property administration company.',
  postcode: '1010',
  street:
    'Eichenstraße 12–18, Residential Complex “Eichenhof”, Building Entrance B',
}
